import React, { useCallback, useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';
import { adminAPI } from '../../services/api';
import { formatPrice } from '../../utils/helpers';
import { toast } from '../../hooks/use-toast';
import { TxnTable } from './TxnTable';

const FILTERS = [
  { key: '', label: 'Todo retenido' },
  { key: 'in_transit', label: 'En transito' },
  { key: 'frozen', label: 'Congelados' },
];

export const EscrowPanel = () => {
  const [filter, setFilter] = useState('');
  const [txns, setTxns] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = useCallback(() => {
    setTxns(null);
    adminAPI.getEscrow(filter).then(setTxns).catch(() => setTxns([]));
  }, [filter]);

  useEffect(() => { load(); }, [load]);

  const act = async (fn, txn, msg) => {
    if (!window.confirm(msg)) return;
    setBusy(txn.txn_id);
    try {
      const r = await fn(txn.txn_id);
      toast({ title: r.message });
      load();
    } catch (e) {
      toast({ title: e.response?.data?.detail || 'Error', variant: 'destructive' });
    } finally { setBusy(null); }
  };

  const total = (txns || []).reduce((s, t) => s + Math.abs(t.amount || 0), 0);

  return (
    <Card className="bg-gray-800 border-gray-700 overflow-hidden" data-testid="escrow-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 p-4 border-b border-gray-700">
        <div className="flex gap-2">
          {FILTERS.map(f => (
            <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`escrow-filter-${f.key || 'all'}`}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${filter === f.key ? 'bg-purple-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}>
              {f.label}
            </button>
          ))}
        </div>
        <p className="text-sm text-gray-400">Total retenido: <span className="font-mono font-bold text-purple-300" data-testid="escrow-total">{formatPrice(total)}</span></p>
      </div>
      {!txns ? (
        <div className="flex justify-center p-8"><Loader2 className="w-6 h-6 animate-spin text-gray-400" /></div>
      ) : (
        <TxnTable txns={txns} testid="escrow-txns" renderActions={(t, i) => t.status === 'frozen' ? (
          <div className="flex gap-1 justify-center">
            <Button size="sm" disabled={busy === t.txn_id} className="h-7 text-xs bg-green-600 hover:bg-green-700" data-testid={`escrow-release-${i}`}
              onClick={() => act(adminAPI.releaseEscrow, t, 'Liberar este dinero al vendedor?')}>Liberar</Button>
            <Button size="sm" variant="ghost" disabled={busy === t.txn_id} className="h-7 text-xs text-red-400 hover:text-red-300" data-testid={`escrow-refund-${i}`}
              onClick={() => act(adminAPI.refundEscrow, t, 'Reembolsar al comprador (a su billetera)?')}>Reembolsar</Button>
          </div>
        ) : <span className="text-xs text-gray-500">Se libera al entregar</span>} />
      )}
    </Card>
  );
};
